import { Link as RouterLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { Body2, Grid, H5, Link as DhlLink } from '@dhl-ui/components'
import type { LabelRequestDto } from '~/modules/label/model'
import { useUser } from '~/modules/users/hooks'
import { useOrganisation } from '~/modules/organisations/hooks'
import { presentName } from '~/modules/users/helpers'

type Props = {
  pieceId: string
  labelRequest: LabelRequestDto
}
export const LabelRequestHeader = ({
  pieceId,
  labelRequest: {
    auth,
    body: { application, userId, organisationId },
  },
}: Props) => {
  const { t } = useTranslation()
  const { organisation } = useOrganisation(organisationId)
  const { user } = useUser(userId)

  return (
    <Grid
      container
      direction="row"
      justifyContent="space-between"
      gap={1}
      data-testid="label-request-header"
      sx={{ mr: 1 }}
    >
      {user && (
        <Grid>
          <Body2 variant="tertiary">{t('admin.labelPage.headings.user')}</Body2>
          <DhlLink title="Get details of shipment label" href={`/users/details/${userId}?labelPid=${pieceId}`}>
            <H5 data-testid="label-request-header-user">{presentName(user)}</H5>
          </DhlLink>
        </Grid>
      )}
      {organisation && (
        <Grid>
          <Body2 variant="tertiary">{t('admin.labelPage.headings.organisation')}</Body2>
          <DhlLink
            title="Get details of shipment label"
            href={`/organisations/details/${organisationId}?labelPid=${pieceId}`}
          >
            <H5 data-testid="label-request-header-organisation">{organisation.name}</H5>
          </DhlLink>
        </Grid>
      )}
      <Grid>
        <Body2 variant="tertiary">{t('admin.labelPage.headings.application')}</Body2>
        <H5>{application ?? 'api'}</H5>
      </Grid>
      {auth.keyDesc && (
        <Grid>
          <Body2 variant="tertiary">{t('admin.labelPage.headings.keyDesc')}</Body2>
          <H5>{auth.keyDesc}</H5>
        </Grid>
      )}
      <Grid>
        <Body2 variant="tertiary">{t('admin.labelPage.headings.shipment')}</Body2>
        <H5>{pieceId}</H5>
      </Grid>
    </Grid>
  )
}
